import styled from "styled-components";

export const TabList = styled.div`
  display: flex;
  justify-content: start;
  background: #edf2f7; /* Slightly different background for tabs */
`;

export const Tab = styled.button`
  flex-grow: 1; /* Tabs take equal width */
  padding: 10px 20px;
  border: none;
  border-bottom: 3px solid transparent; /* Makes the active tab stand out */
  background: ${({ active }) => (active ? "#fff" : "#edf2f7")};
  outline: none;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? "bold" : "normal")};

  &:hover {
    background: #e2e8f0; /* Hover effect */
  }
`;

export const TabPanel = styled.div`
  padding: 20px;
`;
